<template>
  <div class="module-sidebar">
    <div class="module-list-top">
      <div
        v-for="module in topModules"
        :key="module.id"
        class="module-item"
        :class="{ active: currentModule === module.id }"
        @click="selectModule(module.id)"
        :title="module.name"
      >
        <i :class="module.icon" />
      </div>
    </div>
    
    <div class="module-list-bottom">
      <div
        v-for="module in bottomModules"
        :key="module.id"
        class="module-item"
        :class="{ active: currentModule === module.id }"
        @click="selectModule(module.id)"
        :title="module.name"
      >
        <i :class="module.icon" />
      </div>
    </div>
  </div>
</template>

<script setup>import { ref, computed } from 'vue';
const emit = defineEmits(['module-change']);
const currentModule = ref('bpm');

const allModules = ref([
 { id: 'bpm', name: 'BPM流程', icon: 'fas fa-clipboard-list' },
 { id: 'doc', name: '文档中心', icon: 'fas fa-book-open' },
 { id: 'email', name: '邮件系统', icon: 'fas fa-envelope' },
 { id: 'message', name: '消息中心', icon: 'fas fa-bell' },
 { id: 'srm', name: 'SRM供应商', icon: 'fas fa-truck' },
 { id: 'schedule', name: '排程系统', icon: 'fas fa-calendar-alt' },
 { id: 'app', name: 'APP管理', icon: 'fas fa-mobile-alt' },
 { id: 'kanban', name: '看板系统', icon: 'fas fa-columns' },
 { id: 'hr', name: 'HR人事', icon: 'fas fa-users' },
 { id: 'erp', name: 'ERP系统', icon: 'fas fa-building' },
 { id: 'mes', name: 'MES制造', icon: 'fas fa-industry' },
 { id: 'wms', name: 'WMS仓储', icon: 'fas fa-warehouse' },
 { id: 'plm', name: 'PLM产品', icon: 'fas fa-box-open' },
 { id: 'crm', name: 'CRM客户', icon: 'fas fa-handshake' }
]);

const bottomModuleIds = ['ai'];

const topModules = computed(() => {
  return allModules.value.filter(m => !bottomModuleIds.includes(m.id));
});

const bottomModules = computed(() => {
  return [
    { id: 'ai', name: 'AI模型', icon: 'fas fa-microchip' }
  ];
});
const selectModule = (moduleId) => {
 if (currentModule.value !== moduleId) {
 currentModule.value = moduleId;
 emit('module-change', moduleId);
 }
};
</script>

<style scoped>
.module-sidebar {
  width: 60px;
  min-height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background: linear-gradient(180deg, #1f2937 0%, #111827 100%);
  border-right: 1px solid #374151;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
}

.module-list-top {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.module-list-bottom {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: auto;
  padding-bottom: 20px;
}

.module-item {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  color: #9ca3af;
  font-size: 20px;
  position: relative;
}

.module-item:hover {
  background: rgba(240, 173, 78, 0.15);
  color: #f0ad4e;
  transform: scale(1.05);
}

.module-item.active {
  background: linear-gradient(135deg, #f0ad4e 0%, #ec971f 100%);
  color: #fff;
  box-shadow: 0 4px 12px rgba(240, 173, 78, 0.35);
}

.module-item.active:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 16px rgba(240, 173, 78, 0.45);
}

.module-item::after {
  content: attr(title);
  position: absolute;
  left: 100%;
  margin-left: 12px;
  padding: 6px 12px;
  background: #1f2937;
  color: #fff;
  font-size: 12px;
  border-radius: 6px;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s;
  z-index: 100;
  border: 1px solid #374151;
}

.module-item:hover::after {
  opacity: 1;
  visibility: visible;
}
</style>